




































import { computed, defineComponent, ref } from '@vue/composition-api';
import { format, parseISO }               from 'date-fns';
import EventIconMapperService             from '@/services/EventIconMapperService';
import { IEventData }                     from '@/interfaces/IEventData';
import store                              from '@/store/index';
import MapService                         from '@/services/MapService';
import RedrawService                      from '@/services/RedrawService';
import useOverlay                         from '@/components/composers/useOverlay';
import router                             from '@/routes/routes';

const Event: object = defineComponent({
  name: 'Event',
  props: {
    data: {
      name: 'data',
      type: Object,
      required: true,
    },
  },
  filters: {
    time(date: string): string {
      try {
        return format(
          parseISO(date),
          'h:MM ',
        );
      } catch (e) {
        return '';
      }
    },
  },
  setup(props) {
    const { hideOverlay } = useOverlay();

    const eventData = props.data.properties as IEventData;

    const readMore = ref(false);

    const iconType = computed(() => EventIconMapperService(eventData.category.eventCode));

    const jumpToEvent = () => {
      // powrót do mapy
      hideOverlay();
      router.push('/');

      // wyświetlamy wszystkie warstwy z wypadkami ponieważ
      // jest to konieczne do zbliżenia na mapę
      store.commit('enableEventsLayer');
      store.commit('enableEventsAccidentsLayer');
      store.commit('enableEventsBuildingLayer');
      store.commit('enableEventsBlocksLayer');
      store.commit('enableEventsHazardLayer');

      const redrawService: RedrawService =
        new RedrawService(new MapService(store.state.leafletMapInstance));
      redrawService.redrawMap();

      store.dispatch('panAndShowModalForEvent', {
        eventId: eventData.id,
      });
    };

    return {
      readMore,
      iconType,
      jumpToEvent,
    };
  },
});
export default Event;
